<div class="sidenav-menu-items" [class.menu-left]="menuLeft">
  <div>
    <ng-container *ngIf="menuLeft">
      <ng-container *ngIf="desktop; else tablet">
        <div class="profile">
          <span class="title"> Profile </span>
          <span class="staff">EBO Staff</span>
        </div>
      </ng-container>
      <ng-template #tablet>
        <ebo-dropdown
          *ngIf="((botOptions$ | async)?.length > 0 && hideVASelector == false) && (isBotCreated$ | async)"
          [title]="'Virtual Agent'"
          [options]="botOptions$ | async"
          [value]="selectedBotId$ | async"
          (selectionChange)="setBot($event)"
          [placeholder]="'Select a Virtual Agent'"
        >
        </ebo-dropdown>
      </ng-template>
    </ng-container>

    <div class="buttons-container">
      <ng-container *ngFor="let item of menuItems;">
        <button
          mat-icon-button
          class="icon"
          *ngIf="!item.disabled"
          [class.active]="isActiveRoute(item)"
          (click)="navigateTo(item.state)"
          tabindex="-1"
          [matTooltip]="menuLeft ? null : item.name"
          matTooltipPosition="right"
          [disableRipple]="true"
        >
          <mat-icon [svgIcon]="item.svgIcon" aria-hidden="false"></mat-icon>
          <ng-container *ngIf="menuLeft">
            <span class="name"> {{item.name}} </span>
          </ng-container>
        </button>
      </ng-container>
    </div>

    <ng-container *ngIf="!desktop">
      <mat-divider></mat-divider>
      <div class="buttons-container second-menu">
        <button mat-icon-button class="icon" *ngFor="let secondItem of secondMenuItems;" (click)="secondItem.onClick()">
          <mat-icon [svgIcon]="secondItem.svgIcon" aria-hidden="false"></mat-icon>
          <span class="name"> {{secondItem.name}} </span>
        </button>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="menuLeft">
    <div class="sidenav-footer">
      <button (click)="drawer.toggle()" matTooltip="Close menu" matTooltipPosition="right" class="open-menu-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none">
          <path
            d="M5.60893 0.0271637C2.60257 0.291557 0.19662 2.72784 0.0142658 5.6935C0.012405 5.72248 0.00930377 5.75025 0.00620251 5.77801C0.00310126 5.80819 0 5.83234 0 5.85528V18.1296C0 18.1586 0.00310126 18.1882 0.00682276 18.2226C0.00992402 18.2504 0.012405 18.2787 0.0142658 18.3089C0.129012 20.1627 1.14064 21.8993 2.71918 22.9545C3.63281 23.5654 4.69096 23.9221 5.7795 23.9855C5.81237 23.9873 5.84277 23.9903 5.87254 23.994C5.90355 23.9976 5.92836 24 5.95131 24H26.0481C26.071 24 26.0958 23.9976 26.1268 23.994C26.1566 23.9909 26.187 23.9873 26.2193 23.9855C27.2104 23.927 28.1873 23.6221 29.0445 23.1042C30.7062 22.0985 31.8009 20.3679 31.9727 18.4749C31.9752 18.4459 31.9764 18.4067 31.9783 18.3675C31.982 18.2769 31.9851 18.2009 32 18.1357V5.86313C31.9839 5.78767 31.9814 5.70799 31.9783 5.63978C31.9764 5.59632 31.9752 5.55406 31.9727 5.52509C31.8065 3.69667 30.7651 1.99925 29.1872 0.985135C28.3467 0.44488 27.3791 0.113484 26.3904 0.02656C26.3632 0.0241455 26.3222 0.0229382 26.2794 0.0211273C26.1858 0.0175055 26.1051 0.0138836 26.0363 0H5.96185C5.89673 0.0144873 5.82106 0.0169018 5.72988 0.0205237C5.68708 0.0223346 5.64367 0.0235418 5.60955 0.02656L5.60893 0.0271637ZM12.1532 2.10911H25.888C26.5778 2.12299 27.2489 2.30589 27.8363 2.6391C29.0867 3.3526 29.8632 4.6637 29.8632 6.06051L29.8651 17.9178C29.8651 19.2518 29.1878 20.4899 28.0533 21.2293C27.4225 21.6446 26.6813 21.874 25.9116 21.8915H25.9048H12.1532V2.10911ZM6.17398 2.10971H10.0152V21.8933H6.20809C6.20313 21.8933 6.19755 21.8933 6.19259 21.8933C5.58598 21.8933 4.9986 21.7647 4.44658 21.5106L4.44348 21.5094C3.04171 20.846 2.13552 19.4456 2.13552 17.9407L2.13677 6.04542C2.13677 4.5484 3.04481 3.1528 4.4503 2.49061C4.9955 2.2401 5.5742 2.11273 6.17336 2.10971H6.17398Z"
            fill="white"
          />
        </svg>
      </button>
      <span class="version">v {{ appVersion }}</span>
    </div>
  </ng-container>
</div>
